var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4835047B-ECFD-4876-8210-BE61A494CF79") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-290.000000, -477.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "process",
    transform: "translate(291.000000, 478.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54912221,7.36812048 C2.56530486,9.01551803 2,10.941742 2,13 C2,15.718086 2.98584694,18.2059151 4.6194809,20.1254275 M7.32010562,22.4220374 C8.97804102,23.4236392 10.9217124,24 13,24 C15.6024903,24 17.9938921,23.0962229 19.8774686,21.5854056 M22.47055,18.5988072 C23.4422272,16.9587253 24,15.0445 24,13 C24,10.2125073 22.9631628,7.66718095 21.2541124,5.72864492 M18.8651084,3.69237176 C17.1674737,2.62037631 15.1561852,2 13,2 C10.3633106,2 7.94329388,2.9276861 6.04853929,4.47446888",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-35",
    transform: "translate(16.568154, 2.550717) rotate(-20.000000) translate(-16.568154, -2.550717) ",
    points: "18.5796289 0.568417528 18.5796289 4.53301714 14.5566797 4.53301714"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-35",
    transform: "translate(23.222459, 16.733138) rotate(60.000000) translate(-23.222459, -16.733138) ",
    points: "25.2339339 14.7508382 25.2339339 18.7154378 21.2109847 18.7154378"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-35",
    transform: "translate(9.325139, 23.301473) rotate(156.000000) translate(-9.325139, -23.301473) ",
    points: "11.3366131 21.3191733 11.3366131 25.2837729 7.31366393 25.2837729"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-35",
    transform: "translate(2.610662, 9.626118) rotate(247.000000) translate(-2.610662, -9.626118) ",
    points: "4.62213694 7.64381858 4.62213694 11.6084182 0.599187726 11.6084182"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProcess);
export default __webpack_public_path__ + "static/media/ico_process.4ad947cc16aa14015a1e3a0144ef3714.svg";
export { ForwardRef as ReactComponent };